class ClassWatcher {

    constructor(targetNode, classToWatch, classAddedCallback, classRemovedCallback) {
        this.targetNode = targetNode
        this.classToWatch = classToWatch
        this.classAddedCallback = classAddedCallback
        this.classRemovedCallback = classRemovedCallback
        this.observer = null
        this.lastClassState = targetNode.classList.contains(this.classToWatch)

        this.init()
    }

    init() {
        this.observer = new MutationObserver(this.mutationCallback)
        this.observe()
    }

    observe() {
        this.observer.observe(this.targetNode, { attributes: true })
    }

    disconnect() {
        this.observer.disconnect()
    }

    mutationCallback = mutationsList => {
        for(let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                let currentClassState = mutation.target.classList.contains(this.classToWatch)
                if(this.lastClassState !== currentClassState) {
                    this.lastClassState = currentClassState
                    if(currentClassState) {
                        this.classAddedCallback()
                    }
                    else {
                        this.classRemovedCallback()
                    }
                }
            }
        }
    }
}

function updatePr() {
    
  setTimeout(function() {
  var span = document.getElementsByClassName("money bold_option_price_display")[0];
    console.log(span.innerText);
  var prTxt = span.innerText;
  var subS = prTxt.substring(1, prTxt.length);
  var ps = parseInt(subS);

  var clc = ps * 2;

  
  
  var newPrc = clc.toString();
  var dsc = document.getElementById("dcPr").textContent = '€'.concat(newPrc,',00') ;
  
  console.log("Newly calculated:");
  console.log(newPrc);
}, 100);
    
  }

function displayModalP(bg){
    
    closeMe();
    
    
    
    //Close Swatch Title
    
    
    $(".bold_option_swatch_title").css("opacity","0");
    
    
    
    //
    
    document.getElementById('pImageZoom').style.display = "block";
    
    var modalImg = document.getElementById("img01");
    var caption = document.getElementById("caption");
    
    
    if(bg == "raumschiff")
    {
      modalImg.src = "https://cdn.shopify.com/s/files/1/0588/8147/4739/files/spreview.jpg?v=1643656710";
      caption.innerHTML = "Hintergrund: Raumschiff";
      
    }
    else if(bg == "dagobah")
    {
      modalImg.src = "https://cdn.shopify.com/s/files/1/0588/8147/4739/files/dpreview.jpg?v=1643656710";
      caption.innerHTML = "Hintergrund: Dagobah";
    }
    else if(bg == "tatooine")
    {
      modalImg.src = "https://cdn.shopify.com/s/files/1/0588/8147/4739/files/tpreview.jpg?v=1643656710";
      caption.innerHTML = "Tatooine";
    }
    else if(bg == "hoth")
    {
      modalImg.src = "https://cdn.shopify.com/s/files/1/0588/8147/4739/files/hpreview.jpg?v=1643656710";
      caption.innerHTML = "Hintergrund: Hoth";
    }
    else if(bg == "KircheMug")
    {
      modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/kirche_tasse_preview.jpg?v=1620956169";
      caption.innerHTML = "Hintergrund: Kirche";
    }
     else if(bg == "StadtMug")
    {
      modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/stadt_tasse_preview.jpg?v=1620956169";
      caption.innerHTML = "Hintergrund: Stadt";
    }
    else if(bg == "barPos")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/barg_poster_preview.jpg?v=1616880583";
            caption.innerHTML = "Hintergrund: Bar";

    }
    else if(bg == "beachPos")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/beach_poster_preview.jpg?v=1616880754";
            caption.innerHTML = "Hintergrund: Strand";

    }
    else if(bg == "hollyPos")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/hollywood_poster_preview.jpg?v=1616880814";
            caption.innerHTML = "Hintergrund: Hollywood";

    }
    else if(bg == "parisPos")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/paris_poster_preview.jpg?v=1616880940";
            caption.innerHTML = "Hintergrund: Paris";

    }
    else if(bg == "wolPos")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/wol_poster_preview.jpg?v=1616880992";
            caption.innerHTML = "Hintergrund: Wolken";

    }
    else if(bg == "parisPos")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/paris_poster_preview_9e4b5e4a-43ce-4a59-9a87-9eddb0422117.jpg?v=1617073098";
            caption.innerHTML = "Hintergrund: Paris";

    }
    else if(bg == "sofaMug")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/sofa_tasse_preview.jpg?v=1617072749";
            caption.innerHTML = "Hintergrund: Sofa";

    }
    else if(bg == "sofaMTMug")
    {
      modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/sofamuttertag_tasse_preview.jpg?v=1617268050";
      caption.innerHTML = "Hintergrund: Sofa (Muttertag)";
    }
    else if(bg == "sofaVTMug")
    {
      modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/sofavatertag_tasse_preview.jpg?v=1617268050";
      caption.innerHTML = "Hintergrund: Sofa (Vatertag)";
    }
    else if(bg == "houseMug")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/haus_tasse_preview.jpg?v=1617072750";
            caption.innerHTML = "Hintergrund: Haus";

    }
    else if(bg == "KirchePil")
    {
      modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/kirche_kissen_preview.jpg?v=1620956377";
      caption.innerHTML = "Hintergrund: Kirche";
    }
     else if(bg == "StadtPil")
    {
      modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/stadt_kissen_preview.jpg?v=1620956377";
      caption.innerHTML = "Hintergrund: Stadt";
    }
    else if(bg == "barMug")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/bar_tasse_preview.jpg?v=1617072750";
            caption.innerHTML = "Hintergrund: Bar";

    }
    else if(bg == "wolMug")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/wolken_tasse_preview.jpg?v=1617072748";
            caption.innerHTML = "Hintergrund: Wolken";

    }
    else if(bg == "sofaPil")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/sofa_kissen_preview.jpg?v=1617144583";
            caption.innerHTML = "Hintergrund: Sofa";

    }
    else if(bg == "sofaMTPil")
    {
      modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/sofamuttertag_kissen_preview_0d64e467-8487-430c-b098-9cab15173f0c.jpg?v=1617268324";
      caption.innerHTML = "Hintergrund: Sofa (Muttertag)";
    }
    else if(bg == "sofaVTPil")
    {
      modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/sofavatertag_kissen_preview_1baf9b72-43fb-4d2a-8fc6-665029b21d88.jpg?v=1617268325";
      caption.innerHTML = "Hintergrund: Sofa (Vatertag)";
    }
    else if(bg == "housePil")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/haus_kissen_preview.jpg?v=1617144582";
            caption.innerHTML = "Hintergrund: Haus";

    }
    else if(bg == "houseMTPil")
    {
      modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/hausmuttertag_kissen_preview_f132e4e8-4e5b-4abe-b9ba-817b4c9f59e5.jpg?v=1617268325";
      caption.innerHTML = "Hintergrund: Haus (Muttertag)";
    }
     else if(bg == "houseVTPil")
    {
      modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/hausvatertag_kissen_preview_e39b4b18-4ef5-4e82-b3c9-fb024caf12da.jpg?v=1617268324";
      caption.innerHTML = "Hintergrund: Haus (Vatertag)";
    }
    else if(bg == "barPil")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/bar_kissen_preview.jpg?v=1617144582";
            caption.innerHTML = "Hintergrund: Bar";

    }
    else if(bg == "parisPil")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/paris_kissen_preview.jpg?v=1617144582";
            caption.innerHTML = "Hintergrund: Paris";

    }
    else if(bg == "wolPil")
    {
            modalImg.src = "https://cdn.shopify.com/s/files/1/0248/0213/2058/files/wolken_kissen_preview.jpg?v=1617144582";
            caption.innerHTML = "Hintergrund: Wolken";

    }
  }
  
$(window).load(function(){
  
  
  updatePr();
 
      
    $('.bold_option.bold_option_swatch').each(function(i, obj) {
      
      
      if ($(this).find($('.bold_option_title')).text().indexOf("Hintergrund") >= 0)
      {
        
        $(this).find($('.bold_option_value_element')).each(function(i, obj) {
          
          
          
          //POSTER/BLANKETS
          $(this).find($('.sw_1666236_654445')).each(function(i, obj) {
          
          
            if($(this).val() == 'Raumschiff')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;raumschiff&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
              
            }
            else if($(this).val() == 'Hoth')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;hoth&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
            }
            else if($(this).val() == 'Dagobah')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;dagobah&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
            }
            else if($(this).val() == 'Tatooine')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;tatooine&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
            }
             else if($(this).val() == 'Haus (Muttertag)')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;houseMTPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div><div id="newIco" style="width: 32px;position: absolute;top: 0;right: 0;"><img src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/new.png?v=1617149247" <="" img=""></div>');
            }
             else if($(this).val() == 'Haus (Vatertag)')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;houseVTPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div><div id="newIco" style="width: 32px;position: absolute;top: 0;right: 0;"><img src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/new.png?v=1617149247" <="" img=""></div>');
            }
            else if($(this).val() == 'Bar')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;barPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
            }
            else if($(this).val() == 'Strand')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;beachPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
            }
            else if($(this).val() == 'Hollywood')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;hollyPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
            }
             else if($(this).val() == 'Paris')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;parisPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
              
            }
             else if($(this).val() == 'Wolken')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;wolPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
              
            }
             else if($(this).val() == 'Einfarbig')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a a href="#einfarbig" onclick="closeMe(); hideTT();" rel="modal:open"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/info_13213_1.png?v=1617525002"></img></a></div>');
              
            }
            else if($(this).val() == 'Individuell')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a a href="#individuell" onclick="closeMe(); hideTT();" rel="modal:open"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/info_13213_1.png?v=1617525002"></img></a></div>');
              
            }
            else if($(this).val() == 'Bildgetreu')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a a href="#bildgetreu" onclick="closeMe(); hideTT();" rel="modal:open"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/info_13213_1.png?v=1617525002"></img></a></div>');
              
            }
            else
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px; color:white;">X</div>');

            }
    		
            });
          
          //MUGS
          
          $(this).find($('.sw_1079770_433150')).each(function(i, obj) {
          if($(this).val() == 'Sofa')
          {
            
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;sofaMug&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');

          }
            else if($(this).val() == 'Stadt')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;StadtMug&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div><div id="newIco" style="width: 32px;position: absolute;top: 0;right: 0;"><img src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/new.png?v=1617149247" <="" img=""></div>');
            }
            else if($(this).val() == 'Kirche')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;KircheMug&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div><div id="newIco" style="width: 32px;position: absolute;top: 0;right: 0;"><img src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/new.png?v=1617149247" <="" img=""></div>');
            }
          else if($(this).val() == 'Haus')
          {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;houseMug&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
          }
            else if($(this).val() == 'Haus (Muttertag)')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;houseMTMug&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div><div id="newIco" style="width: 32px;position: absolute;top: 0;right: 0;"><img src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/new.png?v=1617149247" <="" img=""></div>');
            }
             else if($(this).val() == 'Haus (Vatertag)')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;houseVTMug&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div><div id="newIco" style="width: 32px;position: absolute;top: 0;right: 0;"><img src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/new.png?v=1617149247" <="" img=""></div>');
            }
          else if($(this).val() == 'Bar')
          {
              
            $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;barMug&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
          }
            else if($(this).val() == 'Wolken')
            {
               $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;wolMug&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');

            }
            else if($(this).val() == 'Einfarbig')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a a href="#einfarbig" onclick="closeMe(); hideTT();" rel="modal:open"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/info_13213_1.png?v=1617525002"></img></a></div>');
              
            }
            else if($(this).val() == 'Individuell')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a a href="#individuell" onclick="closeMe(); hideTT();" rel="modal:open"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/info_13213_1.png?v=1617525002"></img></a></div>');
              
            }
            else if($(this).val() == 'Bildgetreu')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a a href="#bildgetreu" onclick="closeMe(); hideTT();" rel="modal:open"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/info_13213_1.png?v=1617525002"></img></a></div>');
              
            }
            else
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px; color:white;">X</div>');
            }
          
         });
          
          
          
          //BLANKETS
           $(this).find($('.sw_1064456_527119')).each(function(i, obj) {
          
          
            if($(this).val() == 'Sofa')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;sofaPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
              
            }
             else if($(this).val() == 'Stadt')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;Stadt&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div><div id="newIco" style="width: 32px;position: absolute;top: 0;right: 0;"><img src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/new.png?v=1617149247" <="" img=""></div>');
            }
            else if($(this).val() == 'Kirche')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;Kirche&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div><div id="newIco" style="width: 32px;position: absolute;top: 0;right: 0;"><img src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/new.png?v=1617149247" <="" img=""></div>');
            }
            else if($(this).val() == 'Haus')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;housePos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
            }
              else if($(this).val() == 'Haus (Muttertag)')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;houseMTPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div><div id="newIco" style="width: 32px;position: absolute;top: 0;right: 0;"><img src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/new.png?v=1617149247" <="" img=""></div>');
            }
             else if($(this).val() == 'Haus (Vatertag)')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;houseVTPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div><div id="newIco" style="width: 32px;position: absolute;top: 0;right: 0;"><img src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/new.png?v=1617149247" <="" img=""></div>');
            }
            else if($(this).val() == 'Bar')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;barPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
            }
            else if($(this).val() == 'Strand')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;beachPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
            }
            else if($(this).val() == 'Hollywood')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;hollyPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
            }
             else if($(this).val() == 'Paris')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;parisPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
              
            }
             else if($(this).val() == 'Wolken')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;wolPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
              
            }
             else if($(this).val() == 'Einfarbig')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a a href="#einfarbig" onclick="closeMe(); hideTT();" rel="modal:open"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/info_13213_1.png?v=1617525002"></img></a></div>');
              
            }
            else if($(this).val() == 'Individuell')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a a href="#individuell" onclick="closeMe(); hideTT();" rel="modal:open"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/info_13213_1.png?v=1617525002"></img></a></div>');
              
            }
            else if($(this).val() == 'Bildgetreu')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a a href="#bildgetreu" onclick="closeMe(); hideTT();" rel="modal:open"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/info_13213_1.png?v=1617525002"></img></a></div>');
              
            }
            else
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px; color:white;">X</div>');

            }
    		
            });
          
          
          //PILLOWS
          
          
          
           $(this).find($('.sw_1362736_439896')).each(function(i, obj) {
          
          
            if($(this).val() == 'Sofa')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;sofaPil&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
              
            }
             else if($(this).val() == 'Stadt')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;StadtPil&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div><div id="newIco" style="width: 32px;position: absolute;top: 0;right: 0;"><img src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/new.png?v=1617149247" <="" img=""></div>');
            }
            else if($(this).val() == 'Kirche')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;KirchePil&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div><div id="newIco" style="width: 32px;position: absolute;top: 0;right: 0;"><img src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/new.png?v=1617149247" <="" img=""></div>');
            }
            else if($(this).val() == 'Haus')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;housePil&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
            }
             else if($(this).val() == 'Haus (Muttertag)')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;houseMTPil&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div><div id="newIco" style="width: 32px;position: absolute;top: 0;right: 0;"><img src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/new.png?v=1617149247" <="" img=""></div>');
            }
             else if($(this).val() == 'Haus (Vatertag)')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;houseVTPil&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div><div id="newIco" style="width: 32px;position: absolute;top: 0;right: 0;"><img src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/new.png?v=1617149247" <="" img=""></div>');
            }
            else if($(this).val() == 'Bar')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;barPil&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
            }
            else if($(this).val() == 'Strand')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;beachPil&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
            }
            else if($(this).val() == 'Hollywood')
            {
              
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;hollyPos&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
            }
             else if($(this).val() == 'Paris')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;parisPil&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
              
            }
             else if($(this).val() == 'Wolken')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a href="javascript:displayModalP(&quot;wolPil&quot;);"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/mg.png?v=1616877477"></img></a></div>');
              
            }
             else if($(this).val() == 'Einfarbig')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a a href="#einfarbig" onclick="closeMe(); hideTT();" rel="modal:open"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/info_13213_1.png?v=1617525002"></img></a></div>');
              
            }
            else if($(this).val() == 'Individuell')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a a href="#individuell" onclick="closeMe(); hideTT();" rel="modal:open"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/info_13213_1.png?v=1617525002"></img></a></div>');
              
            }
            else if($(this).val() == 'Bildgetreu')
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px;"><a a href="#bildgetreu" onclick="closeMe(); hideTT();" rel="modal:open"><img style="width: 16px; height: 16px" src="https://cdn.shopify.com/s/files/1/0248/0213/2058/files/info_13213_1.png?v=1617525002"></img></a></div>');
              
            }
            else
            {
              $(this).parent().append('<div id="mag" style="margin-top: 5px; color:white;">X</div>');

            }
    		
            });
          
          
		});
         
      }
          

    });
   
   
   
   
   
   
});